import {WYSIWYGEditor} from './WYSIWYGEditor';
import {initialProps} from './utils';

export {
  WYSIWYGEditor,
  initialProps as editorProps,
};
